<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="设备地址">
                <a-input v-model="listQuery.devMac" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-table
        :loading="loading"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false">
        <span slot="devMac" slot-scope="text, record">
          <ellipsis :length="20" tooltip>{{ record.devMac }}</ellipsis>
        </span>
        <span slot="settingName" slot-scope="text, record">
          <ellipsis :length="15" tooltip>{{ record.settingName }}</ellipsis>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ record.createTime | moment }}
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="listQuery.current"
        :total="total"
        :page-size="listQuery.size"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { qryDeviceData } from '@/api/com/device'
import Ellipsis from '@/components/Ellipsis'
export default {
  name: '',
  components: { Ellipsis },
  data () {
    return {
      loading: false,
      columns: [
        { title: '用户名称', dataIndex: 'userName', align: 'center' },
        { title: '设备地址', dataIndex: 'devMac', scopedSlots: { customRender: 'devMac' }, align: 'center', width: '200px' },
        { title: '验配名称', dataIndex: 'settingName', scopedSlots: { customRender: 'settingName' }, align: 'center' },
        { title: '左耳500Hz', dataIndex: 'leftKhz500', align: 'center' },
        { title: '左耳1KHz', dataIndex: 'leftKhz1', align: 'center' },
        { title: '左耳2KHz', dataIndex: 'leftKhz2', align: 'center' },
        { title: '左耳4KHz', dataIndex: 'leftKhz4', align: 'center' },
        { title: '左耳6KHz', dataIndex: 'leftKhz6', align: 'center' },
        { title: '左耳8KHz', dataIndex: 'leftKhz8', align: 'center' },
        { title: '右耳500Hz', dataIndex: 'rightKhz500', align: 'center' },
        { title: '右耳1KHz', dataIndex: 'rightKhz1', align: 'center' },
        { title: '右耳2KHz', dataIndex: 'rightKhz2', align: 'center' },
        { title: '右耳4KHz', dataIndex: 'rightKhz4', align: 'center' },
        { title: '右耳6KHz', dataIndex: 'rightKhz6', align: 'center' },
        { title: '右耳8KHz', dataIndex: 'rightKhz8', align: 'center' }
      ],
      listQuery: {
        current: 1,
        size: 10
      },
      total: 0,
      list: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList() {
      qryDeviceData(this.listQuery).then(res => {
        console.log('===', res)
        this.list = res.data.records
        this.total = Number(res.data.total)
      })
    },
    // 查询
    handleQuery() {
      this.listQuery.current = 1
      this.getList()
    },
    resetQuery() {
      this.listQuery = {
        current: 1,
        size: 10
      }
      this.getList()
    },
    onShowSizeChange (current, size) {
      this.listQuery.size = size
      this.getList()
    },
    changeSize (current, size) {
      this.listQuery.current = current
      this.listQuery.size = size
      this.getList()
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
